export const environment = {
  production: false,
  developerUrl: 'https://cradlecode.com',
  appLinks: {
    android: 'https://play.google.com/store/apps/details?id=com.cradlecode.cradleresident',
    ios: 'https://apps.apple.com/mx/app/cradleresident/id6738028738',
    appGallery: 'https://appgallery.cloud.huawei.com/app/C113460043'
  },
  contact: {
    whatsappNumber: '5215519661990',
    whatsappDisplay: '(55) 1966 1990',
    email: 'contacto@cradleresident.com.mx',
    social: {
      x: 'https://x.com/cradleresident_',
      facebook: 'https://www.facebook.com/cradleresident',
      instagram: 'https://www.instagram.com/cradleresident',
      tiktok: 'https://www.tiktok.com/@cradleresident',
      youtube: 'https://youtube.com/@cradleresident'
    }
  }
};
